// Dependency Injection Container - OOP Pattern (Singleton)
import { ApiClient } from './ApiClient';
import { AuthRepository } from '../repositories/AuthRepository';
import { MessageRepository } from '../repositories/MessageRepository';
import { GroupRepository } from '../repositories/GroupRepository';
import { UserRepository } from '../repositories/UserRepository';
import { AuthService } from './AuthService';
import { MessageService } from './MessageService';
import { GroupService } from './GroupService';
import { UserService } from './UserService';
import ContactService from './ContactService';
import ClientService from './ClientService';
import DamService from './DamService';
import { MessageTemplateService } from './MessageTemplateService';

class ServiceContainer {
  private static instance: ServiceContainer;
  private apiClient: ApiClient;
  private authRepository: AuthRepository;
  private messageRepository: MessageRepository;
  private groupRepository: GroupRepository;
  private userRepository: UserRepository;
  private authService: AuthService;
  private messageService: MessageService;
  private groupService: GroupService;
  private userService: UserService;
  private contactService: ContactService;
  private clientService: ClientService;
  private damService: DamService;
  private messageTemplateService: MessageTemplateService;

  private constructor() {
    // API Client
    const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    this.apiClient = new ApiClient(apiUrl);

    // Repositories
    this.authRepository = new AuthRepository(this.apiClient);
    this.messageRepository = new MessageRepository(this.apiClient);
    this.groupRepository = new GroupRepository(this.apiClient);
    this.userRepository = new UserRepository(this.apiClient);

    // Services
    this.authService = new AuthService(this.authRepository);
    this.messageService = new MessageService(this.messageRepository);
    this.groupService = new GroupService(this.groupRepository);
    this.userService = new UserService(this.userRepository);
    this.contactService = new ContactService(this.apiClient);
    this.clientService = new ClientService(this.apiClient);
    this.damService = new DamService(this.apiClient);
    this.messageTemplateService = new MessageTemplateService(this.apiClient);
  }

  static getInstance(): ServiceContainer {
    if (!ServiceContainer.instance) {
      ServiceContainer.instance = new ServiceContainer();
    }
    return ServiceContainer.instance;
  }

  getApiClient(): ApiClient {
    return this.apiClient;
  }

  getAuthService(): AuthService {
    return this.authService;
  }

  getMessageService(): MessageService {
    return this.messageService;
  }

  getGroupService(): GroupService {
    return this.groupService;
  }

  getUserService(): UserService {
    return this.userService;
  }

  getContactService(): ContactService {
    return this.contactService;
  }

  getClientService(): ClientService {
    return this.clientService;
  }

  getDamService(): DamService {
    return this.damService;
  }

  getMessageTemplateService(): MessageTemplateService {
    return this.messageTemplateService;
  }
}

export default ServiceContainer;
